import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import i18nContext from '@components/i18n/i18nContext';
import { filterNodesByLangcode } from '@helpers/languages';

const DEFAULT_LANGCODE = 'en';

export function useMainNavigation() {
  const { lng } = useContext(i18nContext);
  const langcode = lng || DEFAULT_LANGCODE;

  const result = {
    allMenuLinkContentMenuLinkContent: {
      edges: [
        {
          node: {
            id: '41ec6903-1d48-5038-b073-d2d0e11ac2ff',
            title: 'Group 1',
            link: {
              options: {
                attributes: null,
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: '5ca1e8eb-65d1-4621-a059-acb8653d2a99',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            id: 'e724d0f9-4180-5d78-b824-c4caaf966d48',
            title: 'Group 2',
            link: {
              options: {
                attributes: null,
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: '8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            id: '2586c3b3-3939-515c-bdcf-ebb8ec09da24',
            title: 'Group 3',
            link: {
              options: {
                attributes: null,
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: '2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            id: '336f79a6-3a75-57ff-890b-1e28341e5739',
            title: 'Group 4',
            link: {
              options: {
                attributes: null,
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 3,
            drupal_id: '1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            id: 'ac3a6dd9-6346-50d8-8dba-e1d292751a1d',
            title: 'Group 5',
            link: {
              options: {
                attributes: null,
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 4,
            drupal_id: '6b4e7206-e25c-4a67-af7d-572b935ffde2',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            id: '139004da-eb79-5769-8c76-5a556865951d',
            title: 'Lucid Air',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/air/',
              title: '',
              uri: 'internal:/air',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: '9dc52a74-08c2-42ed-9a23-6c276b21329e',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            id: '7746d47f-b10f-51c3-a100-28d1d1df9667',
            title: 'More about Lucid',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: 'f4c94f5e-0490-432b-bd72-2624a6f26652',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: 'a94a96b8-241e-57d5-b7e2-bda5bd25c96b',
            title: 'Company',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: '890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: '7185741c-30f1-5b94-84ff-42da11715b97',
            title: 'Legal',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/legal/',
              title: '',
              uri: 'internal:/legal',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: '309e1c8c-5153-43c6-9ea3-d536d25e4a5e',
            drupal_parent_menu_item:
              'menu_link_content:6b4e7206-e25c-4a67-af7d-572b935ffde2',
          },
        },
        {
          node: {
            id: '373fa2d9-7776-5167-a9c1-07d63b619eca',
            title: 'Sign In',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'hide',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: 'portal/login/',
              title: '',
              uri: 'internal:/portal/login/',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: '4da7be9b-95e0-4839-8665-e6f5cd6284b5',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            id: '26f0c57e-d099-59db-a389-03320adb9e1b',
            title: 'Overview',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/air/',
              title: '',
              uri: 'internal:/air',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: 'd9468a26-c750-49a0-9b10-6e5409ca0aa4',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '7e5f29fc-9da0-5929-96d6-a6a2ec18593c',
            title: 'Design',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'air/design/',
              title: '',
              uri: 'internal:/air/design',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: 'ba4e7a33-7871-406e-b25e-c58dd304f53a',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '56ddb844-3d0b-5c1f-a604-02f96e19af1c',
            title: 'Charging',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/charging/',
              title: '',
              uri: 'internal:/charging',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 3,
            drupal_id: 'ff275cd6-ebde-47a1-9364-f7a975da5996',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: 'b9fb1b92-10a1-5646-8d22-c284c48cf556',
            title: 'Performance',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'air/performance/',
              title: '',
              uri: 'internal:/air/performance',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: '7b89f3bf-7277-412e-91d0-29b980f2bd8d',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '3cd272cf-66c7-511f-bfc2-f4f53adf9b31',
            title: 'Connectivity',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'air/connectivity/',
              title: '',
              uri: 'internal:/air/connectivity',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 4,
            drupal_id: 'fc3e6ba6-447c-460e-bcce-c7921407b834',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '9f8fb53b-ec8c-5293-93e4-42dd7847e4a2',
            title: 'Specs',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'air/specs/',
              title: '',
              uri: 'internal:/air/specs',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 5,
            drupal_id: 'abead162-0e54-40b7-8dcd-7d076cc9a9c2',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '45666cff-e5bd-5a8a-b66e-a93fd76a43fb',
            title: 'Dream Edition',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'air/dream-edition/',
              title: '',
              uri: 'internal:/air/dream-edition',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 6,
            drupal_id: '9f22f244-b91b-43fb-b25e-81932ca46c75',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '409dff1d-db58-594b-9efe-1e262f0f47e9',
            title: 'Reserve',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'air/reserve/',
              title: '',
              uri: 'internal:/air/reserve',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: '161eb1b4-5727-48f6-882b-dbdf8734f988',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            id: 'bbbc39e7-a5c7-5618-97cf-18ed04e7b616',
            title: 'Stories',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/stories/',
              title: '',
              uri: 'internal:/stories',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 3,
            drupal_id: '224c0dc8-f91e-49a4-9a1f-d2b096313f3d',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: '9eda9abd-0192-590a-ab2c-c2cf8a1e40d2',
            title: 'Race-proven Performance',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/race-proven/',
              title: '',
              uri: 'internal:/race-proven',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: '58b9d8cc-4ca4-4076-9999-b2ff5c81f128',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            id: '5b433325-79af-59ba-9e88-114c45abd90e',
            title: 'Purchase & Ownership',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ownership/',
              title: '',
              uri: 'internal:/ownership',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: 'e43609a4-ae62-44f2-b9e8-f031e31c8ee1',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            id: '36d66c14-8040-5c62-a236-e207a1497af9',
            title: 'Project Gravity',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/future-models/',
              title: '',
              uri: 'internal:/future-models',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: '0d82a0b8-b724-4b30-bada-6fd1a0ba32b5',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            id: 'e1493580-4b3e-52f4-ac92-460020909edd',
            title: 'FAQ',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/faq/',
              title: '',
              uri: 'internal:/faq',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 3,
            drupal_id: 'd33ab6ec-6d42-4e92-bc32-afa4b9ee1f50',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            id: '90d4b4a1-d207-5c00-9a14-414b842a8f6f',
            title: 'Leadership',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'company/leadership/',
              title: '',
              uri: 'internal:/company/leadership',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: '63251eb3-79c0-40d6-8d4d-97d18b6d23d3',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            id: 'e74c8272-d78e-5ab5-b53a-98032e4b6994',
            title: 'Sustainability',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/sustainability/',
              title: '',
              uri: 'internal:/sustainability',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: 'b75be3b3-7955-4a53-ab16-a05540ae61ea',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            id: '8938d223-73ed-5b4a-885b-8a433d4554c7',
            title: 'Investors',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'https://ir.lucidmotors.com',
              title: '',
              uri: 'https://ir.lucidmotors.com',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: '9c26bca7-78a1-44d3-9d5c-658b6f45fa32',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: '2f12c857-44a0-51c7-b746-234cee969913',
            title: 'My Account',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: 'portal/reservations/',
              title: '',
              uri: 'internal:/portal/reservations/',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: '7efc65bc-9d71-4687-94e1-457ac5f04ab5',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            id: 'dafeb912-2224-5ac3-b4bf-ead64bc38d1b',
            title: 'Sign Out',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'hide',
                },
              },
              uri_alias: 'portal/logout/',
              title: '',
              uri: 'internal:/portal/logout/',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: '190c7950-d78c-4001-aa75-af2193e488e8',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            id: '3c01e06b-616d-5a47-9229-49bd9ada4122',
            title: 'Events',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/events/',
              title: '',
              uri: 'internal:/events',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: '03ef38ad-586f-4afa-8679-d05a9db6a7d2',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            id: '63af5895-c184-5639-85fe-4a045729f2ea',
            title: 'Careers',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/careers/',
              title: '',
              uri: 'internal:/careers',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 4,
            drupal_id: '14da123d-a711-4103-b9ed-bbf48721493f',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: 'ef5c9570-ed4b-5857-bfba-5e5888562848',
            title: 'Contact',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/contact/',
              title: '',
              uri: 'internal:/contact',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: 'dd03d8cd-32b6-4463-802e-1388b982aa1a',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            id: '391accc4-4688-5feb-9589-e4590a1475a4',
            title: 'Locations',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/locations/',
              title: '',
              uri: 'internal:/locations',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: '7906b581-669a-469b-a9f1-5a58cba21b34',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            id: '30325050-921d-5714-b9b9-0411c6428abe',
            title: 'Media Room',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/media-room/',
              title: '',
              uri: 'internal:/media-room',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: '790a49d8-3e7e-479d-9570-b03d80763e8f',
            drupal_parent_menu_item:
              'menu_link_content:6b4e7206-e25c-4a67-af7d-572b935ffde2',
          },
        },
        {
          node: {
            id: '1ed123df-cdf9-5724-9e25-acbcd49274eb',
            title: 'About Us',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/company/',
              title: '',
              uri: 'internal:/company',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: 'a6c06a9d-65fa-4ebf-ae1b-cf2f08bfbb49',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            id: 'f690de21-c5ba-5981-bc9b-9160dc079710',
            title: 'Stay Updated',
            link: {
              options: {
                attributes: {
                  type: 'button',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/subscribe/',
              title: '',
              uri: 'internal:/subscribe',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 3,
            drupal_id: '3eca708b-8ee5-4fa8-808e-659e76634752',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            id: '94cb8c57-6a39-52e5-915e-9c311c132a79',
            title: 'Design Yours',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'air/configure/',
              title: '',
              uri: 'internal:/air/configure',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: '0fe4947c-18ce-499a-a0fe-a26d4af5a901',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            id: '62025eec-4ec3-500e-9dcc-0cb088b6ac84',
            title: 'Store',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'https://store.lucidmotors.com/',
              title: '',
              uri: 'https://store.lucidmotors.com/',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 3,
            drupal_id: '7528a84b-0bd6-445c-af33-c0da5b22c81f',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            id: '82047436-020f-5454-95b8-b3a3647230b2',
            title: 'لوسِد أير',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/air/',
              title: '',
              uri: 'internal:/air',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: '9dc52a74-08c2-42ed-9a23-6c276b21329e',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            id: 'ed9d035e-65af-5481-81b4-5ad91a712836',
            title: 'المزيد عن لوسِد',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: 'f4c94f5e-0490-432b-bd72-2624a6f26652',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: 'be59e434-0baf-582a-83fe-ad8f6d99ef91',
            title: 'الشركة',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: '890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: '739a4b8e-bc7e-56a9-9241-da89c67fc14b',
            title: 'قانوني',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/legal/',
              title: '',
              uri: 'internal:/legal',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: '309e1c8c-5153-43c6-9ea3-d536d25e4a5e',
            drupal_parent_menu_item:
              'menu_link_content:6b4e7206-e25c-4a67-af7d-572b935ffde2',
          },
        },
        {
          node: {
            id: '975717bb-3985-55ea-a2a6-70ec5b8c812b',
            title: 'دخول',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'hide',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/arportal/login/',
              title: '',
              uri: 'internal:/portal/login/',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: '4da7be9b-95e0-4839-8665-e6f5cd6284b5',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            id: '72567bdc-b08e-5366-ab39-aa214fbdb15c',
            title: 'نظرة عامة',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/air/',
              title: '',
              uri: 'internal:/air',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: 'd9468a26-c750-49a0-9b10-6e5409ca0aa4',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: 'ee46507e-9067-5101-996d-8640af1355f3',
            title: 'صمم',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/arair/design/',
              title: '',
              uri: 'internal:/air/design',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: 'ba4e7a33-7871-406e-b25e-c58dd304f53a',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '4db9c725-c472-5064-947b-e41aaa6b6d9d',
            title: 'الشحن',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/charging/',
              title: '',
              uri: 'internal:/charging',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 3,
            drupal_id: 'ff275cd6-ebde-47a1-9364-f7a975da5996',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: 'c386322a-2bf4-5100-a966-8d19599a9698',
            title: 'الأداء',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/arair/performance/',
              title: '',
              uri: 'internal:/air/performance',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: '7b89f3bf-7277-412e-91d0-29b980f2bd8d',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: 'cfa5e77b-1a37-5f27-a3c2-1a67a84f3218',
            title: 'الإتصال',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/arair/connectivity/',
              title: '',
              uri: 'internal:/air/connectivity',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 4,
            drupal_id: 'fc3e6ba6-447c-460e-bcce-c7921407b834',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '056c68bd-f6d3-5ec6-8d43-67ea3116f5de',
            title: 'المواصفات',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/arair/specs/',
              title: '',
              uri: 'internal:/air/specs',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 5,
            drupal_id: 'abead162-0e54-40b7-8dcd-7d076cc9a9c2',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '14b3cfb4-795c-5bd3-acb4-88e2a6b57cba',
            title: 'إصدار أير دريم',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/arair/dream-edition/',
              title: '',
              uri: 'internal:/air/dream-edition',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 6,
            drupal_id: '9f22f244-b91b-43fb-b25e-81932ca46c75',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '5885a73a-6157-53a0-8433-be7653be94d3',
            title: 'الحجز',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/arair/reserve/',
              title: '',
              uri: 'internal:/air/reserve',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: '161eb1b4-5727-48f6-882b-dbdf8734f988',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            id: 'e1ba81ae-eb3f-564f-a98a-6fbbed472ada',
            title: 'مدونات',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/stories/',
              title: '',
              uri: 'internal:/stories',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 3,
            drupal_id: '224c0dc8-f91e-49a4-9a1f-d2b096313f3d',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: '566019fb-2335-54f5-84b6-7d8907e0dab6',
            title: 'تكنولوجيا اختبرت في السباقات',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/race-proven/',
              title: '',
              uri: 'internal:/race-proven',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: '58b9d8cc-4ca4-4076-9999-b2ff5c81f128',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            id: '66b06625-efad-52a1-8274-0d70f70efb2c',
            title: 'تجربة الشراء والتملك',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/ownership/',
              title: '',
              uri: 'internal:/ownership',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: 'e43609a4-ae62-44f2-b9e8-f031e31c8ee1',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            id: 'ec75da97-2b76-59df-846a-2074f4b3b788',
            title: 'جرافيتي بروجيكت',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/future-models/',
              title: '',
              uri: 'internal:/future-models',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: '0d82a0b8-b724-4b30-bada-6fd1a0ba32b5',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            id: 'fd58b098-46a5-5415-bd8c-a4ee8114ab20',
            title: 'أسئلة وأجوبة',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/faq/',
              title: '',
              uri: 'internal:/faq',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 3,
            drupal_id: 'd33ab6ec-6d42-4e92-bc32-afa4b9ee1f50',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            id: 'a7c63a3b-47b3-5a81-b1ba-ace4bdda2e0a',
            title: 'القيادة',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/arcompany/leadership/',
              title: '',
              uri: 'internal:/company/leadership',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: '63251eb3-79c0-40d6-8d4d-97d18b6d23d3',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            id: '416f57c5-56e8-50d6-b96a-41494f2405b8',
            title: 'الاستدامة',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/sustainability/',
              title: '',
              uri: 'internal:/sustainability',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: 'b75be3b3-7955-4a53-ab16-a05540ae61ea',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            id: 'b21b7a57-92bb-5d72-9017-d246f65c99e5',
            title: 'المستثمرون',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'https://ir.lucidmotors.com',
              title: '',
              uri: 'https://ir.lucidmotors.com',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: '9c26bca7-78a1-44d3-9d5c-658b6f45fa32',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: 'a74c55be-c905-5f0d-bb91-c9fb4fd1c755',
            title: 'حسابي',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/arportal/reservations/',
              title: '',
              uri: 'internal:/portal/reservations/',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: '7efc65bc-9d71-4687-94e1-457ac5f04ab5',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            id: '478b4af8-d24c-5712-ac38-19d43e8b6630',
            title: 'خروج',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'hide',
                },
              },
              uri_alias: '/arportal/logout/',
              title: '',
              uri: 'internal:/portal/logout/',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: '190c7950-d78c-4001-aa75-af2193e488e8',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            id: '8807e2f1-5d51-51b4-8f8c-07669d42daa4',
            title: 'الأحداث',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/events/',
              title: '',
              uri: 'internal:/events',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: '03ef38ad-586f-4afa-8679-d05a9db6a7d2',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            id: 'ce1da1dc-c541-5139-9af3-fb19674edec1',
            title: 'فرص العمل',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/careers/',
              title: '',
              uri: 'internal:/careers',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 4,
            drupal_id: '14da123d-a711-4103-b9ed-bbf48721493f',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: '37bd0679-5451-5ef1-9bab-04c219f94bba',
            title: 'التواصل',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/contact/',
              title: '',
              uri: 'internal:/contact',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: 'dd03d8cd-32b6-4463-802e-1388b982aa1a',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            id: '4dd2c9cd-7404-5047-8b21-221120eeeb7f',
            title: 'ابحث عن المعارض ومراكز الخدمة',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/locations/',
              title: '',
              uri: 'internal:/locations',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: '7906b581-669a-469b-a9f1-5a58cba21b34',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            id: 'd9839a07-fea5-55b7-be08-20bbf53ce837',
            title: 'غرفة الأخبار',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/media-room/',
              title: '',
              uri: 'internal:/media-room',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: '790a49d8-3e7e-479d-9570-b03d80763e8f',
            drupal_parent_menu_item:
              'menu_link_content:6b4e7206-e25c-4a67-af7d-572b935ffde2',
          },
        },
        {
          node: {
            id: '903d3efb-d6cd-594c-b997-2d1258914b37',
            title: 'من نحن',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/company/',
              title: '',
              uri: 'internal:/company',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: 'a6c06a9d-65fa-4ebf-ae1b-cf2f08bfbb49',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            id: 'c142e1ce-0243-5dd5-bb75-1b21e84118f3',
            title: 'ابق على اطلاع',
            link: {
              options: {
                attributes: {
                  type: 'button',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/ar/subscribe/',
              title: '',
              uri: 'internal:/subscribe',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 3,
            drupal_id: '3eca708b-8ee5-4fa8-808e-659e76634752',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            id: '00c5d946-70e6-5c57-b774-61f566b30547',
            title: 'صمم سيارتك',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/arair/configure/',
              title: '',
              uri: 'internal:/air/configure',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: '0fe4947c-18ce-499a-a0fe-a26d4af5a901',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            id: '289f3e21-05a9-5236-8670-121881df99a8',
            title: 'Lucid Air',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/air/',
              title: '',
              uri: 'internal:/air',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: '9dc52a74-08c2-42ed-9a23-6c276b21329e',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            id: 'c1492a48-5aab-5ef1-811a-1c1fb6e98c48',
            title: 'En savoir plus sur Lucid',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: 'f4c94f5e-0490-432b-bd72-2624a6f26652',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: '4abc3502-c78f-55ef-a47b-53085f20004a',
            title: 'Entreprise',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 1,
            drupal_id: '890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: '06535c2a-23b8-581e-a4bd-79b05922e71b',
            title: 'Juridique',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/legal/',
              title: '',
              uri: 'internal:/legal',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 1,
            drupal_id: '309e1c8c-5153-43c6-9ea3-d536d25e4a5e',
            drupal_parent_menu_item:
              'menu_link_content:6b4e7206-e25c-4a67-af7d-572b935ffde2',
          },
        },
        {
          node: {
            id: '702ab437-419a-5d54-9797-71271d7c694e',
            title: 'Connectez-vous',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'hide',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/fr-caportal/login/',
              title: '',
              uri: 'internal:/portal/login/',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: '4da7be9b-95e0-4839-8665-e6f5cd6284b5',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            id: '11d84047-8d8f-581e-9db5-7f2803f77e8e',
            title: 'Aperçu',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/air/',
              title: '',
              uri: 'internal:/air',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: 'd9468a26-c750-49a0-9b10-6e5409ca0aa4',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '6a12cc29-d965-5b32-bb50-1caebba62d94',
            title: 'Conception',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-caair/design/',
              title: '',
              uri: 'internal:/air/design',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 1,
            drupal_id: 'ba4e7a33-7871-406e-b25e-c58dd304f53a',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '0a824ec1-67f8-51c9-af06-8a77850c34a5',
            title: 'Recharge',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/charging/',
              title: '',
              uri: 'internal:/charging',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 3,
            drupal_id: 'ff275cd6-ebde-47a1-9364-f7a975da5996',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: 'a4185987-59fb-5e30-baca-a28b20ddaed9',
            title: 'Performance',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-caair/performance/',
              title: '',
              uri: 'internal:/air/performance',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: '7b89f3bf-7277-412e-91d0-29b980f2bd8d',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '04c4699a-2679-5c67-8838-7c41f5a5323e',
            title: 'Connectivité',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-caair/connectivity/',
              title: '',
              uri: 'internal:/air/connectivity',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 4,
            drupal_id: 'fc3e6ba6-447c-460e-bcce-c7921407b834',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: 'f83e1f75-86d5-5b1c-b890-83c938548f52',
            title: 'Spécifications',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-caair/specs/',
              title: '',
              uri: 'internal:/air/specs',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 5,
            drupal_id: 'abead162-0e54-40b7-8dcd-7d076cc9a9c2',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '4805f265-2c57-5889-b530-582c9992c0d2',
            title: 'Dream Edition',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-caair/dream-edition/',
              title: '',
              uri: 'internal:/air/dream-edition',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 6,
            drupal_id: '9f22f244-b91b-43fb-b25e-81932ca46c75',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '44b1665e-79b0-5fb0-b3bf-a56f522d326a',
            title: 'Réservez',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-caair/reserve/',
              title: '',
              uri: 'internal:/air/reserve',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: '161eb1b4-5727-48f6-882b-dbdf8734f988',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            id: '96fd9534-2eac-5206-abb3-f7554d38250f',
            title: 'Histoires',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/stories/',
              title: '',
              uri: 'internal:/stories',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 3,
            drupal_id: '224c0dc8-f91e-49a4-9a1f-d2b096313f3d',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: '1ffd459d-3ef3-5b3f-a781-6f8e626e2850',
            title: 'Une performance éprouvée en piste',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/race-proven/',
              title: '',
              uri: 'internal:/race-proven',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: '58b9d8cc-4ca4-4076-9999-b2ff5c81f128',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            id: '4379dc34-6031-5ce8-8c16-bcbf94c8a751',
            title: 'Achat et propriété',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/ownership/',
              title: '',
              uri: 'internal:/ownership',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 1,
            drupal_id: 'e43609a4-ae62-44f2-b9e8-f031e31c8ee1',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            id: 'bc07bbe0-e3ab-5712-9cbf-171d0cb1ea7f',
            title: 'Projet Gravity',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/future-models/',
              title: '',
              uri: 'internal:/future-models',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: '0d82a0b8-b724-4b30-bada-6fd1a0ba32b5',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            id: '9ba42749-00b0-512e-b261-4adc58be6bd7',
            title: 'FAQ',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/faq/',
              title: '',
              uri: 'internal:/faq',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 3,
            drupal_id: 'd33ab6ec-6d42-4e92-bc32-afa4b9ee1f50',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            id: 'd4114f54-6a65-51da-ade7-bf173e71f4ac',
            title: 'Leadership',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-cacompany/leadership/',
              title: '',
              uri: 'internal:/company/leadership',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 1,
            drupal_id: '63251eb3-79c0-40d6-8d4d-97d18b6d23d3',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            id: 'db938f24-7075-55db-bdb8-3eccd475d13b',
            title: 'Développement durable',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/sustainability/',
              title: '',
              uri: 'internal:/sustainability',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: 'b75be3b3-7955-4a53-ab16-a05540ae61ea',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            id: '3ff7370d-35b7-50e8-b89a-392e9adc6a83',
            title: 'Investisseurs',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'https://ir.lucidmotors.com',
              title: '',
              uri: 'https://ir.lucidmotors.com',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: '9c26bca7-78a1-44d3-9d5c-658b6f45fa32',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: '186b31bb-9ce3-5a6a-8a41-f3d6e5fe7a22',
            title: 'Mon compte',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/fr-caportal/reservations/',
              title: '',
              uri: 'internal:/portal/reservations/',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 1,
            drupal_id: '7efc65bc-9d71-4687-94e1-457ac5f04ab5',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            id: 'bfed6717-de78-59fc-8bae-20fba093bc2c',
            title: 'Se déconnecter',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'hide',
                },
              },
              uri_alias: '/fr-caportal/logout/',
              title: '',
              uri: 'internal:/portal/logout/',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: '190c7950-d78c-4001-aa75-af2193e488e8',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            id: 'b74cf721-8529-53a4-9321-3369d0da77a8',
            title: 'Événements',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/events/',
              title: '',
              uri: 'internal:/events',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: '03ef38ad-586f-4afa-8679-d05a9db6a7d2',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            id: 'f42f003c-345a-59a7-a94e-db96b9e9129f',
            title: 'Carrières',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/careers/',
              title: '',
              uri: 'internal:/careers',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 4,
            drupal_id: '14da123d-a711-4103-b9ed-bbf48721493f',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: 'd5ccf64e-27e0-5e56-a75d-a9bf51e90b8d',
            title: 'Contact',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/contact/',
              title: '',
              uri: 'internal:/contact',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: 'dd03d8cd-32b6-4463-802e-1388b982aa1a',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            id: '69b40c82-3fb7-5633-90f5-92706ccdabad',
            title: 'Établissements',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/locations/',
              title: '',
              uri: 'internal:/locations',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 1,
            drupal_id: '7906b581-669a-469b-a9f1-5a58cba21b34',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            id: 'eb107994-4245-5734-a6a1-f58a16c592c7',
            title: 'Salle des médias',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/media-room/',
              title: '',
              uri: 'internal:/media-room',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: '790a49d8-3e7e-479d-9570-b03d80763e8f',
            drupal_parent_menu_item:
              'menu_link_content:6b4e7206-e25c-4a67-af7d-572b935ffde2',
          },
        },
        {
          node: {
            id: '3d09a1c9-5b02-5c34-a038-72a8ff6ba960',
            title: 'À propos de nous',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/company/',
              title: '',
              uri: 'internal:/company',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: 'a6c06a9d-65fa-4ebf-ae1b-cf2f08bfbb49',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            id: '6cb8635b-e265-565b-810e-7daa07d27c01',
            title: 'Restez à jour',
            link: {
              options: {
                attributes: {
                  type: 'button',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/fr-ca/subscribe/',
              title: '',
              uri: 'internal:/subscribe',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 3,
            drupal_id: '3eca708b-8ee5-4fa8-808e-659e76634752',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            id: 'eb8a6765-c379-5798-9ab5-33ea1d2f704c',
            title: 'Concevez la vôtre',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-caair/configure/',
              title: '',
              uri: 'internal:/air/configure',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 1,
            drupal_id: '0fe4947c-18ce-499a-a0fe-a26d4af5a901',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            id: 'dfcc364c-aa62-55e1-b6ee-09c438b55589',
            title: 'Lucid Air',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/air/',
              title: '',
              uri: 'internal:/air',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: '9dc52a74-08c2-42ed-9a23-6c276b21329e',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            id: 'e90abcad-64b2-5ebf-9a91-913d30df6331',
            title: 'Meer over Lucid',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: 'f4c94f5e-0490-432b-bd72-2624a6f26652',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: 'd978bce7-a95c-59b3-baed-9acc220481aa',
            title: 'Bedrijf',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: '890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: '37119c2c-b02c-5655-846a-bd8a1cd91ae1',
            title: 'Juridisch',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/legal/',
              title: '',
              uri: 'internal:/legal',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: '309e1c8c-5153-43c6-9ea3-d536d25e4a5e',
            drupal_parent_menu_item:
              'menu_link_content:6b4e7206-e25c-4a67-af7d-572b935ffde2',
          },
        },
        {
          node: {
            id: '7fd101d7-97f4-5f62-9697-b32f7dc5ed3f',
            title: 'Aanmelden',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'hide',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/nl-nlportal/login/',
              title: '',
              uri: 'internal:/portal/login/',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: '4da7be9b-95e0-4839-8665-e6f5cd6284b5',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            id: '493fd9d5-9655-5208-8d35-5755ea7bc319',
            title: 'Overzicht',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/air/',
              title: '',
              uri: 'internal:/air',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: 'd9468a26-c750-49a0-9b10-6e5409ca0aa4',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '8378fccc-6fec-50cf-a53a-9511ea605aa3',
            title: 'Ontwerp',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nlair/design/',
              title: '',
              uri: 'internal:/air/design',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: 'ba4e7a33-7871-406e-b25e-c58dd304f53a',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: 'd5a0ce60-e518-5076-b205-61e460ec0d64',
            title: 'Opladen',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/charging/',
              title: '',
              uri: 'internal:/charging',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 3,
            drupal_id: 'ff275cd6-ebde-47a1-9364-f7a975da5996',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: 'd8ce1e88-fa34-5590-9a5f-5555f35f8583',
            title: 'Prestaties',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nlair/performance/',
              title: '',
              uri: 'internal:/air/performance',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: '7b89f3bf-7277-412e-91d0-29b980f2bd8d',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '4fb14dd8-73ee-5a1b-a9bb-ed1b75f86f74',
            title: 'Connectiviteit',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nlair/connectivity/',
              title: '',
              uri: 'internal:/air/connectivity',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 4,
            drupal_id: 'fc3e6ba6-447c-460e-bcce-c7921407b834',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: 'd09455db-893e-5e85-9794-77ab3fb4d37e',
            title: 'Specificaties',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nlair/specs/',
              title: '',
              uri: 'internal:/air/specs',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 5,
            drupal_id: 'abead162-0e54-40b7-8dcd-7d076cc9a9c2',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '5721c4c2-77b9-5fe2-a719-f688b7bf675d',
            title: 'Dream Edition',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nlair/dream-edition/',
              title: '',
              uri: 'internal:/air/dream-edition',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 6,
            drupal_id: '9f22f244-b91b-43fb-b25e-81932ca46c75',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            id: '2e1ee5ad-13a8-5773-9b32-c248c515df7f',
            title: 'Reserveren',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nlair/reserve/',
              title: '',
              uri: 'internal:/air/reserve',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: '161eb1b4-5727-48f6-882b-dbdf8734f988',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            id: 'ad1ec8c4-030c-572f-bd09-8a8773243d51',
            title: 'Verhalen',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/stories/',
              title: '',
              uri: 'internal:/stories',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 3,
            drupal_id: '224c0dc8-f91e-49a4-9a1f-d2b096313f3d',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: 'cf9dcccf-f91d-533d-ae6d-20ab2f74ec70',
            title: 'Bewezen prestaties',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/race-proven/',
              title: '',
              uri: 'internal:/race-proven',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: '58b9d8cc-4ca4-4076-9999-b2ff5c81f128',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            id: '464c30ae-f775-5dfd-b6e9-140a85dcce99',
            title: 'Aanschaf en eigendom',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/ownership/',
              title: '',
              uri: 'internal:/ownership',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: 'e43609a4-ae62-44f2-b9e8-f031e31c8ee1',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            id: '642b21a1-94cf-58a8-a467-aa120d66af2d',
            title: 'Project Gravity',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/future-models/',
              title: '',
              uri: 'internal:/future-models',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: '0d82a0b8-b724-4b30-bada-6fd1a0ba32b5',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            id: '5033c6c3-7ad7-51a3-91ba-bb0584d15b4a',
            title: 'FAQ',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/faq/',
              title: '',
              uri: 'internal:/faq',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 3,
            drupal_id: 'd33ab6ec-6d42-4e92-bc32-afa4b9ee1f50',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            id: '11ae388e-5c89-5de0-8297-3050f0d6ec98',
            title: 'Leiderschap',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nlcompany/leadership/',
              title: '',
              uri: 'internal:/company/leadership',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: '63251eb3-79c0-40d6-8d4d-97d18b6d23d3',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            id: '3a4b1992-46f7-58e0-be3c-ffeea234e3f5',
            title: 'Duurzaamheid',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/sustainability/',
              title: '',
              uri: 'internal:/sustainability',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: 'b75be3b3-7955-4a53-ab16-a05540ae61ea',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            id: 'bb5da460-5651-59d3-be92-38fe6d38283c',
            title: 'Investeerders',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'https://ir.lucidmotors.com',
              title: '',
              uri: 'https://ir.lucidmotors.com',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: '9c26bca7-78a1-44d3-9d5c-658b6f45fa32',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: 'b0aa2b1f-8ce5-5607-b7f1-727e86b2f2a6',
            title: 'Mijn account',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/nl-nlportal/reservations/',
              title: '',
              uri: 'internal:/portal/reservations/',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: '7efc65bc-9d71-4687-94e1-457ac5f04ab5',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            id: 'ef73e45a-8ad9-5457-9d47-80adc6ab2808',
            title: 'Afmelden',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'hide',
                },
              },
              uri_alias: '/nl-nlportal/logout/',
              title: '',
              uri: 'internal:/portal/logout/',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: '190c7950-d78c-4001-aa75-af2193e488e8',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            id: '207e97a3-9075-5b2c-ab77-c598db5cecad',
            title: 'Evenementen',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/events/',
              title: '',
              uri: 'internal:/events',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: '03ef38ad-586f-4afa-8679-d05a9db6a7d2',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            id: 'cf84b3f3-2067-5468-879e-4f210ce2540f',
            title: 'Vacatures',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/careers/',
              title: '',
              uri: 'internal:/careers',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 4,
            drupal_id: '14da123d-a711-4103-b9ed-bbf48721493f',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            id: 'bfadd704-38ae-5242-a204-359c127d5120',
            title: 'Contact',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/contact/',
              title: '',
              uri: 'internal:/contact',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: 'dd03d8cd-32b6-4463-802e-1388b982aa1a',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            id: '347365e5-e8d1-503b-8c27-7d77c3e4b51d',
            title: 'Vestigingen',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/locations/',
              title: '',
              uri: 'internal:/locations',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: '7906b581-669a-469b-a9f1-5a58cba21b34',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            id: 'bb1dc911-539c-58e5-a54d-231e195dfe31',
            title: 'Laatste nieuws/updates',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/media-room/',
              title: '',
              uri: 'internal:/media-room',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: '790a49d8-3e7e-479d-9570-b03d80763e8f',
            drupal_parent_menu_item:
              'menu_link_content:6b4e7206-e25c-4a67-af7d-572b935ffde2',
          },
        },
        {
          node: {
            id: '49476c0c-2e55-53e4-94ad-ce5b8b3fa847',
            title: 'Over ons',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/company/',
              title: '',
              uri: 'internal:/company',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: 'a6c06a9d-65fa-4ebf-ae1b-cf2f08bfbb49',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            id: 'f6770978-bb9d-5025-ba33-6a92090c9a6c',
            title: 'Blijf op de hoogte',
            link: {
              options: {
                attributes: {
                  type: 'button',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/nl-nl/subscribe/',
              title: '',
              uri: 'internal:/subscribe',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 3,
            drupal_id: '3eca708b-8ee5-4fa8-808e-659e76634752',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            id: '1ef55b09-ab8e-553a-8696-d10eb5aa09a6',
            title: 'Configureren',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nlair/configure/',
              title: '',
              uri: 'internal:/air/configure',
              uri_uuid: '',
            },
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: '0fe4947c-18ce-499a-a0fe-a26d4af5a901',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
      ],
    },
  };

  const { edges } = result.allMenuLinkContentMenuLinkContent;
  const nodes = edges.map(edge => edge.node);
  const root = nodes.slice(0, 5).sort((a, b) => a.weight - b.weight);
  const translated = filterNodesByLangcode(nodes, langcode);
  const parents = [root[1], root[0]];

  const columns = parents.map(parent =>
    translated
      .filter(
        node =>
          typeof node.drupal_parent_menu_item === 'string' &&
          node.drupal_parent_menu_item.indexOf(parent.drupal_id) !== -1
      )
      .sort((a, b) => a.weight - b.weight)
  );
  const sortedColumns = columns.map(column =>
    column.sort((a, b) => a.weight - b.weight)
  );

  // Last child is button
  if (sortedColumns[1] && sortedColumns[1][sortedColumns[1].length - 1]) {
    /**
     *
     * @todo: #newsletter should come from BE
     */
    sortedColumns[1][sortedColumns[1].length - 1].link.uri = '#newsletter';
  }

  return sortedColumns;
}

/**
 *
 * For classes
 *
 */
export const withMainNavigation = Component =>
  Object.assign(
    props => {
      const columns = useMainNavigation();
      let userObj = {};
      if (props.type === 'portal') {
        const { user } =
          useSelector(({ userProfile }) => ({ ...userProfile })) || {};
        userObj = user;
      }

      return <Component columns={columns} user={userObj} {...props} />;
    },
    { displayName: 'withMainNavigation' }
  );
